import Rectangle from '../utils/Rectangle'

import { Axis, Dimension, Position } from './constants'
import applyFlex from './flex'
import LayoutItem from './LayoutItem'

window.lcalls = 0

export default function createLayout(config = new Config()) {
  const layout = (node) => {
    window.lcalls++
    const res = new LayoutItem(config, node)
    res.initializeBase()
    const children = res.children

    // Children initialization on first layout call
    if (!res.initialized) {
      res.initialized = true
      for (let i = 0; i < res.nodes.length; i++) {
        children.push(new LayoutItem(config, res.nodes[i], res))
      }
      res.setOuterPosition(Axis.X, 0)
      res.setOuterPosition(Axis.Y, 0)
    }

    for (let i = 0; i < children.length; i++) {
      layout(children[i])
    }

    // Flexbox
    if (res.isFlex) {
      const flexChildren = children.filter((e) => e.position !== Position.ABSOLUTE)
      const { flexWrap, justifyContent, alignItems } = res.style
      const flexOptions = {
        dimension: res.flexDimension,
        flexWrap,
        justifyContent,
        alignItems,
      }
      const { width, height } = applyFlex(res, flexChildren, flexOptions, layout)
      res.setContentSize(Dimension.WIDTH, width)
      res.setContentSize(Dimension.HEIGHT, height)
    } else {
      const customLayoutResult = config.customLayout(res.node, res)
      if (customLayoutResult) {
        res.setContentSize(Dimension.WIDTH, customLayoutResult.width)
        res.setContentSize(Dimension.HEIGHT, customLayoutResult.height)
      }
    }

    // Absolute positioning
    const absolutePositionedChildren = children.filter((e) => e.position === Position.ABSOLUTE)
    for (const item of absolutePositionedChildren) {
      const { item: containingBox, offsetX, offsetY } = item.getContainingBox()
      if (item.top != null) {
        const pos = offsetY + item.top
        item.setOuterPosition(Axis.Y, pos)
      }
      if (item.left != null) {
        const pos = offsetX + item.left
        item.setOuterPosition(Axis.X, pos)
      }
      if (item.bottom != null) {
        const containingBoxHeight = containingBox ? containingBox.getBoxSize(Dimension.HEIGHT) : 0
        const pos =
          offsetY + containingBoxHeight - item.getOuterSize(Dimension.HEIGHT) - item.bottom
        item.setOuterPosition(Axis.Y, pos)
      }
      if (item.right != null) {
        const containingBoxWidth = containingBox ? containingBox.getBoxSize(Dimension.WIDTH) : 0
        const pos = offsetX + containingBoxWidth - item.getOuterSize(Dimension.WIDTH) - item.right
        item.setOuterPosition(Axis.X, pos)
      }
    }

    config.setSize(res.node, Dimension.WIDTH, res.getBoxSize(Dimension.WIDTH))
    config.setSize(res.node, Dimension.HEIGHT, res.getBoxSize(Dimension.HEIGHT))

    // Calculate own bounding rect
    res.boundingRect = new Rectangle(
      0,
      0,
      res.getBoundingSize(Dimension.WIDTH),
      res.getBoundingSize(Dimension.HEIGHT),
    )
    // Enlarge own rect by children rectangles
    for (let i = 0; i < children.length; i++) {
      res.boundingRect.enlarge(children[i].boundingRect)
    }
    // Move rect by position
    res.boundingRect.x += res._x
    res.boundingRect.y += res._y

    return res
  }

  return layout
}

// Interface
class Config {
  getSize(node, dimension) {}

  getChildren() {}

  getPosition() {}

  getStyle() {}

  setSize(node, dimension, value) {}

  setPosition(node, axis, value) {}

  customLayout(node, layoutItem) {}

  cacheLayout(node, layoutItem) {}
}
